import React, { Component } from "react";
import SchoolBrief from "./components/SchoolBrief";
import SchoolSubject from "./components/SchoolSubject";
import SchoolContact from "./components/SchoolContact";
import SchoolCharter from "./components/SchoolCharter";
import { getQueryValue } from "../../../../utils/tool";
import "./stylePay.css";
import "../../../../index.css";
class SchoolDetailDownPay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markArray: [true, false, false, false],
      css: {
        right: "13px",
      },
    };
  }
  componentDidMount() {
    this.fixCss();
    if (getQueryValue("from") === "majorquery/list") {
      this.setState({
        markArray: [false, true, false],
      });
    }
  }
  render() {
    const { data, hashId, from } = this.props;
    const { markArray, css } = this.state;
    return data === null ? (
      ""
    ) : (
      <div className="schoolDetailDownPay_box">
        <div className="schoolDetailDownPay_box_switch">
          <div
            onClick={() => this.activateTab(0)}
            className={
              markArray[0] === true
                ? "schoolDetailDownPay_box_switch_active fl"
                : "fl"
            }
          >
            学校简介
          </div>
          {/* <div
            style={{ position: "relative" }}
            onClick={() => this.activateTab(1)}
            className={
              markArray[1] === true
                ? "schoolDetailDownPay_box_switch_active fl"
                : "fl"
            }
          >
            招生章程
          </div> */}
          {/* <div
            onClick={() => this.activateTab(2)}
            className={
              markArray[2] === true
                ? "schoolDetailDownPay_box_switch_active fl"
                : "fl"
            }
          >
            专业/选科
          </div> */}
          <div
            style={{ position: "relative" }}
            onClick={() => this.activateTab(3)}
            className={
              markArray[3] === true
                ? "schoolDetailDownPay_box_switch_active fl"
                : "fl"
            }
          >
            <img
              style={{ right: css.right !== "13px" ? css.right : "13px" }}
              alt=""
              className="schoolDetailDownPay_box_switch_hot"
              src={require("../../../../images/school/hot.gif")}
            ></img>
            联系方式
          </div>

          <div className="clear"></div>
        </div>
        <div className="schoolDetailDownPay_box_content">
          <SchoolBrief
            data={data}
            visible={this.state.markArray[0]}
          ></SchoolBrief>
          <SchoolCharter
            data={data}
            visible={this.state.markArray[1]}
          ></SchoolCharter>
          <SchoolSubject
            data={data}
            hashId={hashId}
            visible={this.state.markArray[2]}
            type="school"
            from={from}
          ></SchoolSubject>
          <SchoolContact
            data={data}
            visible={this.state.markArray[3]}
          ></SchoolContact>
        </div>
        <div
          style={{ height: this.state.markArray[1] === true ? 43 : 63 }}
        ></div>
      </div>
    );
  }
  fixCss = () => {
    let minWidth = window.innerWidth;
    if (minWidth === 414 || minWidth === 411) {
      this.setState({
        css: {
          right: "20px",
        },
      });
    } else if (minWidth === 320) {
      this.setState({
        css: {
          right: "9px",
        },
      });
    } else if (minWidth >= 750) {
      this.setState({
        css: {
          right: "78px",
        },
      });
    }
  };
  activateTab = (id) => {
    let tmpMarkArray = [false, false, false, false];
    tmpMarkArray[id] = true;
    this.setState({ markArray: tmpMarkArray });
  };
}

export default SchoolDetailDownPay;



// WEBPACK FOOTER //
// ./src/components/School/SchoolDetail/SchoolDetailDown/indexPay.js